import { render, staticRenderFns } from "./pre-invest.vue?vue&type=template&id=cbe4eee4&scoped=true"
import script from "./pre-invest.vue?vue&type=script&lang=js"
export * from "./pre-invest.vue?vue&type=script&lang=js"
import style0 from "./pre-invest.vue?vue&type=style&index=0&id=cbe4eee4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe4eee4",
  null
  
)

export default component.exports